import React, { useState } from 'react';

// FAQ data-tao ekhane niye aslam
const faqs = [
  { q: "How long does a therapy session last?", a: "Standard individual sessions are 50 to 60 minutes long. However, initial consultations might take slightly longer." },
  { q: "Is our conversation confidential?", a: "Absolutely. Everything discussed in our sessions remains strictly confidential, as per professional ethics and legal guidelines." },
  { q: "How many sessions will I need?", a: "The number of sessions varies depending on your individual goals and the complexity of the issues you wish to address. We'll discuss a personalized plan during our first meeting." },
  { q: "What is the difference between a Psychologist and a Psychiatrist?", a: "Psychologists focus on therapy and behavioral interventions (no medication), while Psychiatrists are medical doctors who can prescribe medication." }
];

function FAQSection() {
  // State gulo ekhane niye elam! App.jsx theke baad dibi eita.
  const [openFaqIndex, setOpenFaqIndex] = useState(null);
  const toggleFaq = (index) => setOpenFaqIndex(prev => (prev === index ? null : index));

  return (
    <section id="faq" className="py-24 px-6 md:px-16 lg:px-24 bg-white">
      <div className="max-w-4xl mx-auto">
        <header className="text-center mb-16">
          <span className="text-xs font-black uppercase tracking-[0.3em] text-ocean-teal">Clarifications</span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-deep-charcoal mt-4">Common Questions</h2>
        </header>

        <div className="space-y-4">
          {faqs.map((faq, index) => {
            const isOpen = openFaqIndex === index;
            return (
              <div 
                key={index} 
                className={`bg-[#FDFBF7] rounded-[2rem] border transition-all duration-500 overflow-hidden ${isOpen ? 'border-ocean-teal/30 shadow-lg' : 'border-gray-100 shadow-sm hover:border-gray-200'}`}
              >
                <button 
                  onClick={() => toggleFaq(index)}
                  aria-expanded={isOpen}
                  className="w-full flex justify-between items-center p-6 md:p-8 text-left outline-none focus-visible:bg-gray-50 transition-colors"
                >
                  <span className={`text-lg md:text-xl font-serif font-bold pr-8 ${isOpen ? 'text-ocean-teal' : 'text-deep-charcoal'}`}>
                    {faq.q}
                  </span>
                  <span className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-all duration-500 ${isOpen ? 'bg-ocean-teal text-white rotate-45' : 'bg-white text-gray-400 shadow-sm'}`}>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"></path></svg>
                  </span>
                </button>
                
                <div 
                  className={`transition-all duration-500 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}
                  aria-hidden={!isOpen}
                >
                  <p className="px-6 md:px-8 pb-6 md:pb-8 text-deep-charcoal/70 leading-relaxed text-md md:text-lg">
                    {faq.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FAQSection;